import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import {getVersion, verifySessionAccount} from "@/services/api";
import { tx } from '@/i18n/pack';

const Login = () => import('@/views/Login.vue');
const Guide = () => import("@/views/Guide.vue");
const Home = () => import("@/views/Home.vue");
const UserGrouping = () => import("@/views/UserGrouping.vue");
const UserGroupingSetting = () => import("@/views/UserGroupingSetting.vue");
const UserGroupingUpload = () => import("@/views/UserGroupingUpload.vue");
const UserManagement = () => import("@/views/UserManagement.vue");
const AccountSettings = () => import("@/views/AccountSettings.vue");
const DataAccess = () => import("@/views/DataAccess.vue");
const StrategyFlow = () => import("@/views/process/StrategyFlow.vue");
const EmailVerify = () => import("@/views/EmailVerify.vue");
const Unsubscribe = () => import("@/views/Unsubscribe.vue");
const Subscribe = () => import("@/views/Subscribe.vue");
const SubscriptionPlan = () => import("@/views/SubscriptionPlan.vue");
const Index = () => import("@/views/Index.vue");
const Router = () => import("@/views/Router.vue");
const Error403 = () => import("@/views/Error403.vue");

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登录 | CartSee',
      titleKey: 'page.title.login'
    },
  },
  {
    path: "/",
    redirect: "/home",
    component: Index,
    name: "index",
    children: [
      {
        path: '/home',
        name: 'Home',
        component: Home,
        meta: {
          title: '首页 | CartSee',
          titleKey: 'page.title.home'
        },
      },
      {
        //营销活动
        path: '/marketing/campaign/',
        redirect: "/cartsee-new/campaign/list",
        name: 'MarketingCampaign',
        component: Router,
        children:[
          {
            path: 'detailed/:id',
            name: 'MarketingCampaignDetailed',
            component: () => import('@/views/campaign/detailed/index.vue'),
            meta: {
              title: '活动明细 | CartSee',
              titleKey: 'page.title.campaignDetail'
            },
          },

        ]
      },
      {
        //营销流程
        path: '/marketing/process/',
        redirect: "/cartsee-new/flow/list",
        name: 'MarketingProcess',
        component: Router,
        children:[
          {
            path: 'list',
            name: 'MarketingProcessList',
            component: () => import("@/views/process/List.vue"),
            meta: {
              title: '营销流程 | CartSee',
              titleKey: 'page.title.flow'
            },
          },
          {
            path: 'detailed/:id',
            name: 'MarketingProcessDetailed',
            component: () => import('@/views/process/detailed/index.vue'),
            meta: {
              title: '策略器明细 | CartSee',
              titleKey: 'page.title.flowDetail'
            },
          },
        ]
      },
      {
        path: '/marketing/process/v2/detailed/:id',
        name: '',
        component: () => import('@/views/process/detailedV2/index.vue'),
      },
      {
        //订阅工具
        path: '/wheel_of_fortune/',
        name: 'wheelOfFortune',
        component: Router,
        children:[
          {
            path: 'list',
            name: 'wheelOfFortuneList',
            component: () => import("@/views/wheelOfFortune/List.vue"),
            meta: {
              title: '订阅工具 | CartSee',
              titleKey: 'page.title.form'
            },
          },
          // abtest
          {
            path: 'abtest',
            name: 'wheelOfFortuneABTest',
            component:() => import("@/views/wheelOfFortune/abtest/index.vue"),
            meta: {
              title: '订阅工具编辑 | CartSee',
              titleKey: 'page.title.formEdit'
            },
          },
          {
            path: 'abtest/:id',
            name: 'wheelOfFortuneABTest',
            component:() => import("@/views/wheelOfFortune/abtest/index.vue"),
            meta: {
              title: '订阅工具编辑 | CartSee',
              titleKey: 'page.title.formEdit'
            },
          },
          //大转盘
          {
            path: 'setting',
            name: 'wheelOfFortuneSettingNew',
            component: () => import("@/views/wheelOfFortune/Setting/index.vue"),
            meta: {
              title: '订阅工具编辑 | CartSee',
              titleKey: 'page.title.formEdit'
            },
          },
          {
            path: 'setting/:id',
            name: 'wheelOfFortuneSetting',
            component:() => import("@/views/wheelOfFortune/Setting/index.vue"),
            meta: {
              title: '订阅工具编辑 | CartSee',
              titleKey: 'page.title.formEdit'
            },
          },
          {
            path: 'setting/copy/:copyId',
            name: 'wheelOfFortuneSetting',
            component:() => import("@/views/wheelOfFortune/Setting/index.vue"),
            meta: {
              title: '订阅工具编辑 | CartSee',
              titleKey: 'page.title.formEdit'
            },
          },
          {
            path: 'check/:id',
            name: 'wheelOfFortuneCheck',
            component: () => import("@/views/wheelOfFortune/Setting/index.vue"),
            meta: {
              title: '订阅工具查看 | CartSee',
              titleKey: 'page.title.formView'
            },
          },
          //弹窗
          {
            path: 'pop',
            name: 'wheelOfFortunePopNew',
            component: () => import("@/views/wheelOfFortune/pop/index.vue"),
            meta: {
              title: '订阅工具编辑 | CartSee',
              titleKey: 'page.title.formEdit'
            },
          },
          {
            path: 'pop/:id',
            name: 'wheelOfFortunePop',
            component: () => import("@/views/wheelOfFortune/pop/index.vue"),
            meta: {
              title: '订阅工具编辑 | CartSee',
              titleKey: 'page.title.formEdit'
            },
          },
          {
            path: 'pop/copy/:copyId',
            name: 'wheelOfFortunePop',
            component: () => import("@/views/wheelOfFortune/pop/index.vue"),
            meta: {
              title: '订阅工具编辑 | CartSee',
              titleKey: 'page.title.formEdit'
            },
          },
        ]
      },
      {
        //用户群
        path: '/user/',
        name: 'user',
        component: Router,
        children:[
          {
            path: 'grouping',
            name: 'UserGrouping',
            component: UserGrouping,
            meta: {
              title: '用户群 | CartSee',
              titleKey: 'page.title.segment'
            },
          },
          {
            path: 'grouping/setting',
            name: 'UserGroupingSetting',
            component: UserGroupingSetting,
            meta: {
              title: '用户群编辑 | CartSee',
              titleKey: 'page.title.segmentEdit'
            },
          },
          {
            path: 'grouping/setting/:id',
            name: 'UserGroupingSettingId',
            component: UserGroupingSetting,
            meta: {
              title: '用户群编辑 | CartSee',
              titleKey: 'page.title.segmentEdit'
            },
          },
          {
            path: 'grouping/upload',
            name: 'UserGroupingUpload',
            component: UserGroupingUpload,
            meta: {
              title: '用户群上传 | CartSee',
              titleKey: 'page.title.segmentUpload'
            },
          },
          {
            path: 'grouping/upload/:id',
            name: 'UserGroupingUploadId',
            component: UserGroupingUpload,
            meta: {
              title: '用户群上传 | CartSee',
              titleKey: 'page.title.segmentUpload'
            },
          },

        ]
      },
      {
        path: '/data/access',
        name: 'DataAccess',
        redirect: '/cartsee-new/data/access',
        component: DataAccess,
        meta: {
          title: '数据接入 | CartSee',
          titleKey: 'page.title.dataAccess'
        },
      },
      {
        path: '/user/management',
        name: 'UserManagement',
        component: UserManagement,
        meta: {
          title: '用户管理 | CartSee',
          titleKey: 'page.title.users'
        },
      },
      {
        path: '/subscription/plan',
        name: 'SubscriptionPlan',
        component: SubscriptionPlan,
        meta: {
          title: '订阅套餐 | CartSee',
          titleKey: 'page.title.plan'
        },
      },
        {
          path: '/403',
          name: 'Error403',
          component: Error403,
          meta: {
            title: '403 | CartSee'
          },
        },

    ]
  },
  {
    path: '/guide',
    name: 'Guide',
    component: Guide,
    meta: {
      title: '新手引导 | CartSee',
      titleKey: 'page.title.guide'
    },
  },
  {
    //在react中
    path: '/account/settings',
    name: 'AccountSettings',
    component: AccountSettings,
    meta: {
      title: '账号设置 | CartSee',
      titleKey: 'page.title.account'
    },
  },

  {
    path: '/strategy/flow',
    name: 'StrategyFlow',
    redirect: '/cartsee-new/strategy/flow/:id',
    component: StrategyFlow,
    meta: {
      title: '流程编辑 | CartSee',
      titleKey: 'page.title.flowEdit'
    },
  },
  {
    path: '/strategy/flow/:id',
    name: 'StrategyFlowId',
    redirect: '/cartsee-new/strategy/flow/:id',
    component: StrategyFlow,
    meta: {
      title: '流程编辑 | CartSee',
      titleKey: 'page.title.flowEdit'
    },
  },
  {
    path: '/strategy/copy/:copyId',
    name: 'StrategyFlowCopyId',
    redirect: '/cartsee-new/strategy/copy/:copyId',
    component: StrategyFlow,
    meta: {
      title: '流程编辑 | CartSee',
      titleKey: 'page.title.flowEdit'
    },
  },
  {
    path: '/strategy/check/:id',
    name: 'StrategyCheckId',
    redirect: '/cartsee-new/strategy/flow/:id',
    component: StrategyFlow,
    meta: {
      title: '流程查看 | CartSee',
      titleKey: 'page.title.flowView'
    },
  },
  {
    path: '/email/verify',
    name: 'EmailVerify',
    component: EmailVerify,
    meta: {
      title: '邮件验证 | CartSee',
      titleKey: 'page.title.emailVerify'
    },
  },
  {
    path: '/unsubscribe',
    name: 'Unsubscribe',
    component: Unsubscribe,
    meta: {
      title: 'Unsubscribe'
    },
  },
  {
    path: '/subscribe',
    name: 'Subscribe',
    component: Subscribe,
    meta: {
      title: 'Subscribe'
    },
  },
  {
    path: '/resubscribe',
    name: 'Resubscribe',
    component: Subscribe,
    meta: {
      title: 'Resubscribe'
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,

});

let appVersion = '';
router.beforeEach((to, from, next) => {
  verifySessionAccount();
  // 跳转arco项目
  if(to.path.startsWith('/cartsee-new')) {
    window.location.replace(process.env.VUE_APP_DOMAIN  + to.path);
  }
  // if (to.matched.length === 0) {
  //   next( {
  //     path: '/error',
  //     query: to.query
  //   })
  //   // 储存错误的路由地址，方便以后使用
  //   sessionStorage.errorUri = to.fullPath;
  //   return;
  // }
  // getVersion().then(res => {
  //   try {
  //     const newVersion = res.data.version;
  //     if (appVersion && appVersion !== newVersion) {
  //       location.reload();
  //     } else {
  //       appVersion = newVersion;
  //     }
  //   } catch (e) {}
  // })

  /* 路由切换时，如果没有就添加，有就跳过执行，添加固定参数 */
  let query = to.query;
  let queryCtrl = false;
  if (from.query.state && !to.query.state) {
    query.state = from.query.state;
    queryCtrl = true;
  }
  if (queryCtrl) {
    next({
      path: to.path,
      query: query
    });
  } else {
    next();
  }

  /* 设置title */
  document.title = tx(null, to.meta?.titleKey || 'page.title.default', to.meta?.title || 'CartSee');

})

export default router;
